module.exports = __webpack_public_path__ + "img/rocket.05796edc.svg";